/**
 * usePlatformDomain
 * -----------------
 * Returns { isPlatform } for the current hostname.
 *
 * When ``platform.<yourdomain>`` serves the app, the axios interceptor
 * automatically sends ``X-Tenant-Slug: platform`` and the backend routes
 * every auth request through the SuperAdmin (superadmins-table) branch.
 * This hook lets the auth pages tweak their branding/copy accordingly —
 * no separate login page needed.
 *
 * ``VITE_PLATFORM_SUBDOMAIN`` overrides the default "platform" prefix
 * (matches the ``PLATFORM_SUBDOMAIN`` setting on the backend).
 */

const PLATFORM_PREFIX = (
    import.meta.env?.VITE_PLATFORM_SUBDOMAIN || "platform"
).toLowerCase();

export function isPlatformHost(hostname) {
    if (!hostname) return false;
    const host = String(hostname).toLowerCase().trim();
    return host === PLATFORM_PREFIX || host.startsWith(`${PLATFORM_PREFIX}.`);
}

export function usePlatformDomain() {
    const hostname =
        typeof window !== "undefined" && window.location
            ? window.location.hostname
            : "";
    return { isPlatform: isPlatformHost(hostname), hostname };
}

export default usePlatformDomain;
